import { doc, updateDoc, serverTimestamp, deleteField } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { db, storage } from '../firebase-config';
import {
  PORTAL_LOGO_EXPORT_PX,
  PORTAL_LOGO_STORAGE_NAME,
  PORTAL_LOGO_DEFAULT_SHAPE,
} from '../constants/portalLogo';

export const PUBLIC_PROFILE_CONSENT_VERSION = 'exec_summary_v1';

const schoolRef = (schoolId) => doc(db, 'schools', schoolId);

export async function setPublishExecutiveSummary(schoolId, publishExecutiveSummary) {
  await updateDoc(schoolRef(schoolId), {
    'publicProfile.publishExecutiveSummary': !!publishExecutiveSummary,
    'publicProfile.consentVersion': PUBLIC_PROFILE_CONSENT_VERSION,
    'publicProfile.updatedAt': serverTimestamp(),
  });
}

export async function uploadPortalLogo(schoolId, blob, shape = PORTAL_LOGO_DEFAULT_SHAPE) {
  const storagePath = `schoolBranding/${schoolId}/${PORTAL_LOGO_STORAGE_NAME}`;
  const storageRef = ref(storage, storagePath);

  try {
    await uploadBytes(storageRef, blob, { contentType: 'image/png' });
  } catch (err) {
    throw err;
  }

  const publicUrl = await getDownloadURL(storageRef);
  const portalLogo = {
    storagePath,
    publicUrl,
    shape: shape === 'square' ? 'square' : 'circle',
    cropVersion: 1,
    updatedAt: new Date().toISOString(),
  };

  await updateDoc(schoolRef(schoolId), { portalLogo });
  return portalLogo;
}

export async function removePortalLogo(schoolId, existingLogo) {
  if (existingLogo?.storagePath) {
    try {
      await deleteObject(ref(storage, existingLogo.storagePath));
    } catch (err) {
      console.warn('Portal logo storage delete skipped:', err);
    }
  }
  await updateDoc(schoolRef(schoolId), { portalLogo: deleteField() });
}

export { PORTAL_LOGO_EXPORT_PX };
